import { QrCode, CreditCard, Truck, Bike, Banknote } from "lucide-react";

export const PayInfo = ({ light = false }) => {
  const items = [
    { icon: QrCode, t: "Pix" },
    { icon: CreditCard, t: "Cartão em até 5x" },
    { icon: Truck, t: "Correios PAC e SEDEX · todo o Brasil" },
    { icon: Bike, t: "Retirada via moto táxi" },
    { icon: Banknote, t: "Dinheiro na retirada" },
  ];
  return (
    <ul data-testid={light ? "payinfo-idealize" : "payinfo-speedmax"} className={`flex flex-wrap gap-x-6 gap-y-3 text-sm ${light ? "font-jost text-[#4a4440]" : "text-zinc-300"}`}>
      {items.map(({ icon: I, t }) => (
        <li key={t} className="flex items-center gap-2"><I className={`h-4 w-4 ${light ? "text-[#b08a3e]" : "text-cyan-300"}`} strokeWidth={1.6} />{t}</li>
      ))}
      <li className={`flex items-center gap-2 ${light ? "text-[#6b625b]" : "text-zinc-400"}`}>Pagamento seguro via Asaas</li>
    </ul>
  );
};
